<template>
  <div id="main_div">
    <!-- Home Section start-->
    <section id="home" class="home">
      <div class="home-decor">
        <div class="home-circle1"><img :src='"../assets/images/main-banner3.png"' alt=""></div>
        <div class="home-circle2"><img :src='"../assets/images/main-banner12.png"' alt=""></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="home-contain">
              <div>
                <h4>Bem vindos a</h4>
                <h1>
                  <span class="f-bold">PRODO</span>
                  <span class="f-color"> SISTEMAS</span>
                </h1>
                <h4>Tenha um software para chamar de seu!</h4>
                <p>Abra caminhos para uma parceria incrível, prepare-se para uma nova era de negócios! Junte-se a nós e desbloqueie oportunidades ilimitadas de crescimento e sucesso. Seja reconhecido como um líder no mercado, com um software de qualidade excepcional, impulsionado pela sua marca e nossa expertise tecnológica.</p>
                <nav class="top-margin">
                  <!-- <a href="#business" class="btn btn-custom theme-color theme-color">Sobre Nós</a> -->
                  <router-link :to="{ name: 'Sobre_nos' }" class="btn btn-custom theme-color theme-color">
                    Conheça nossa história
                  </router-link>
                </nav>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="home-right2">
              <img :src='"../assets/images/Modelo.png"' alt="image" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Section start -->
    <Feature />
    <!-- Feature Section End -->

    <!-- Screenshots Section Start -->
    <Screenshots />
    <!-- Screenshots Section End -->

    <!-- Contact Section start -->
    <Contact_us />
    <!-- Contact Section End -->

    <!-- Footer Section start -->
    <Footer />
    <!-- Footer Section End -->
    <js />
  </div>
</template>
<script>
export default {
  name: 'Home_one',
  beforeCreate: function () {
    document.body.className = ''
  }
}
</script>
<style>
.nav-logo {
  margin-left: 1rem !important;
}

@media (max-width: 575px) {
  .nav-logo {
    margin-left: 0;
  }
}
</style>
<style scoped>
.img-fluid {
    max-width: fit-content;
    height: calc(100vh - 250px);
}
.home-right2 {
  display: none;
    position: absolute;
    width: 100%;
    bottom: 22px;
    left: 110px;

}

@media (min-width: 768px) {
  .home-right2 {
    display: block;
  }
}

@media (max-width: 1366px) {
  .home-right2 {
    position: absolute;
    width: 60%;
    bottom: -20px;
    left: 103px;
  }
.img-fluid {
    max-width: fit-content;
    height: calc(100vh - 50px);
}
}

@media (min-width: 768px) and (max-width: 1365px) {
  .home-right2 {
    width: 80%;
    bottom: 22px;
    left: 35px;
  }
}
/* 
@media (min-width: 1400px) {
  .home-right2 {
    position: absolute;
    width: 80%;
    bottom: -14px;
    left: 103px;
  }
}

@media (min-width: 1400px) {
  .home-right2 {
    width: 70%;
    bottom: -36px;
  }
} */

@media (max-width: 1366px) {
  .home-contain {
    margin-top: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home_one.vue